import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';

import type { LegacyContentMacroParams } from './legacy-content-macro-params.ts';

const manifest: ExtensionManifest<LegacyContentMacroParams> = {
	title: 'Legacy Content Macro',
	type: 'com.atlassian.confluence.migration',
	key: 'legacy-content',
	description: 'Allows editing TinyMCE content',
	icons: {
		'16': () =>
			import(/* webpackChunkName: "loadable-editor-activity" */ '@atlaskit/icon/core/dashboard'),
		'24': () =>
			import(/* webpackChunkName: "loadable-editor-activity" */ '@atlaskit/icon/core/dashboard'),
		'48': () =>
			import(/* webpackChunkName: "loadable-editor-activity" */ '@atlaskit/icon/core/dashboard'),
	},
	modules: {
		nodes: {
			default: {
				type: 'extension',
				render: () =>
					import(
						/* webpackChunkName: "loadable-legacy-content-macro" */ './renderer-extension-handler.tsx'
					),
			},
		},
	},
};

// eslint-disable-next-line import/no-default-export
export default manifest;
